/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { AdvancedFilter } from '../AdvancedFilter';
import { useConfiguredAdvancedFilter } from './hooks';

import type { ConfiguredAdvancedFilterProps as BaseConfiguredAdvancedFilterProps } from './interfaces';
import type { AdvancedFilterValue } from '../AdvancedFilter';

interface ConfiguredAdvancedFilterProps extends BaseConfiguredAdvancedFilterProps<AdvancedFilterValue> {
    sectionId?: string;
}

export const ConfiguredAdvancedFilter: React.FC<ConfiguredAdvancedFilterProps> = ({ sectionId, options, ...restProps }) => {
    const { configuredCols } = useConfiguredAdvancedFilter(sectionId, options.cols);

    if (configuredCols.length === 0) {
        return null;
    }

    return (
        <AdvancedFilter
            {...restProps}
            options={{ header: options.header, cols: configuredCols }}
        />
    );
};
